import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-header-admin',
  templateUrl: './header-admin.component.html',
  styleUrls: ['./header-admin.component.scss'],
})
export class HeaderAdminComponent implements OnInit {

  @Input() selectedOpt:any;
  @Output() emitCurrencies = new EventEmitter();

  constructor(
    private navCtrl: NavController
  ) { }

  ngOnInit() {}

  goTo(url){
    this.navCtrl.navigateForward(url);
  }

}
